export class logRouteRequest {
    routeFrom: string;
    routeTo: string;

    constructor() {}
}